import { Box, GlobalStyles } from "@mui/material";
import { Header } from "../shared/Header";
import { useTenantTheme } from "../themes/TenantThemeProvider";
import background from "../assets/images/bg-pattern.png";

const inlineStyles = (backgroundColor, isPrimaryTheme, reduceBackgroundNoise) => (
  <GlobalStyles
    styles={{
      body: {
        background: backgroundColor,
        ...(isPrimaryTheme && !reduceBackgroundNoise
          ? { backgroundImage: `url(${background})` }
          : {}),
        ...(isPrimaryTheme && reduceBackgroundNoise
          ? {
              backgroundImage: `linear-gradient(rgba(247, 248, 255, 0.92), rgba(247, 248, 255, 0.92)), url(${background})`,
            }
          : {}),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center fixed",
        backgroundSize: "cover",
      },
    }}
  />
);

export function MainLayout(props) {
  const {
    siTheme: { backgroundColor, isPrimaryTheme },
  } = useTenantTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      maxWidth="800px"
      mb={props.compactFooter ? "0" : "32px"}
      mx="auto"
      sx={{ paddingX: { xs: "16px", md: "0" } }}
    >
      {inlineStyles(
        backgroundColor,
        isPrimaryTheme,
        props.reduceBackgroundNoise,
      )}
      <Header
        text={props.helpText}
        helpHref={props.helpHref}
        hideHelp={props.hideHelp}
      />
      {props.children}
    </Box>
  );
}
